import Draw, { DrawEvent } from 'ol/interaction/Draw';
import { useContext, useEffect } from 'react'
import { MapContext } from '../MapContext'
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import Text from 'ol/style/Text';
import { never } from 'ol/events/condition';
import { setDrawState } from '../../../../../state/features/drawStateSlice';
import { DrawStateType } from '../../../../../util/model/drawState';
import { useDispatch } from 'react-redux';
import { WKT } from 'ol/format';
import { setMapCoordinates } from '../../../../../state/features/coordinatesSlice';

interface Props {
    source: any
}

export const DrawPolygon = (props: Props) => {
    const map = useContext(MapContext);
    const dispatch = useDispatch();

    useEffect(() => {

        let draw = new Draw({
            source: props.source,
            type: 'Polygon',
            stopClick: true,
            style: new Style({
                fill: new Fill({
                    color: '#64b5f640',
                }),
                stroke: new Stroke({
                    color: '#3ea1f1',
                    width: 3,
                }),
                image: new CircleStyle({
                    radius: 5,
                    fill: new Fill({
                        color: '#3ea1f1',
                    }),
                }),
            }),
            finishCondition: never,
            condition: function (e: any) {
                //sadece solla çizim yapıyor ve sağla bitiriyor
                if (e.originalEvent.buttons === 1) {
                    return true;
                } else if (e.originalEvent.buttons === 2) {
                    draw.finishDrawing();
                    return false;
                }
                else {
                    return false;
                }
            }
        });

        map.addInteraction(draw);

        drawEnd(draw);

        return () => {
            map.removeInteraction(draw)
        }

    }, [map])

    const drawEnd = (draw: Draw) => {
        draw.on('drawend', (event: any) => {
            const polygonArea = event.feature?.getGeometry().getArea()
            setTextAfterDrawEnd(event, polygonArea);
            dispatch(setDrawState({ drawStateType: DrawStateType.NONE }))
        });
    }

    /**
     * Çizim bittikten sonra ölçüm değerini çizilen nesnenin üzerine yazar. 
     */
    const setTextAfterDrawEnd = (event: DrawEvent, polygonArea: any) => {
        const feature = event.feature;
        polygonArea = polygonArea.toFixed(2);

        event.feature.setStyle(new Style({
            fill: new Fill({
                color: '#64b5f640',
            }),
            stroke: new Stroke({
                color: '#3ea1f1',
                width: 3,
            }),
            image: new CircleStyle({
                radius: 5,
                fill: new Fill({
                    color: '#3ea1f1',
                }),
            }),
            text: new Text({
                text: `${polygonArea}m²`,
                font: "bold 15px 'Open Sans', 'Arial Unicode MS', 'sans-serif'",
                placement: 'point',
                offsetY: -15,
                fill: new Fill({
                    color: 'white',
                }),
                stroke: new Stroke({
                    color: 'black',
                    width: 3,
                }),
            })
        }));

        //aynı çizimi panorama üzerinde de göstermek için
        const wkt = new WKT();
        const wktFeature = wkt.writeFeature(feature)

        const result = {
            type: 'Point',
            feature: wktFeature,
            text: `${polygonArea}m`
        }

        dispatch(setMapCoordinates(result))
    }
    return (
        <>

        </>
    )
}
